import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import EventDetailsItem from './components/EventDetailsItem';

const EventDetails = ({
  singleEvent,
  getEventById,
  resetSingleEventById,
  updateEvent,
  eventGoing,
  eventNotGoing,
  populatePostReportTypes,
  toggleLike,
  toggleCommentLike,
  postComment,
  getFeedItemDetails,
  userImageUrl,
  addAlertToAlerts,
  currentUser
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, postId } = params;
  const mapView = searchParams.get('mapview') || false;

  const singleEventId = id || postId

  useEffect(() => {
    getEventById(singleEventId);
    populatePostReportTypes();

    return () => {
      resetSingleEventById();
    };
  }, []);

  return (
    <div className="event-container feed scroll">
      <GridContainer>
        <div className="event-container--upper">
          <div
            className="event-container-header-back-link"
            onClick={() => navigate(`/events/?mapview=${mapView}`)}
          >
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Event Listings</h3>
        </div>
        {singleEvent ? (
          <EventDetailsItem
            event={singleEvent}
            eventGoing={eventGoing}
            eventNotGoing={eventNotGoing}
            updateEvent={updateEvent}
            singleEventId={singleEventId}
            getFeedItemDetails={getFeedItemDetails}
            userImageUrl={userImageUrl}
            postComment={postComment}
            toggleLike={toggleLike}
            toggleCommentLike={toggleCommentLike}
            addAlertToAlerts={addAlertToAlerts}
            currentUser={currentUser}
          />
        ) : (
          <div className="d-flex pt-4">
            <p className="event-container-text">
              We are unable to find the event. Please try again later.
            </p>
          </div>
        )}
      </GridContainer>
    </div>
  );
};

export default EventDetails;
